namespace Ir.Components.Workbook.DashboardWidget {
    interface IViewModel {
        config: WorkbookConfig;
        dashboard: Dashboard;
        dashboardWidget: DashboardWidget;
        isLoading: KnockoutObservable<boolean>;
        result: any;
        dispose: Function;
        editing: KnockoutObservable<boolean>;
        detailButton: DevExpress.ui.dxButton.Properties;
        removeButton: DevExpress.ui.dxButton.Properties;
        createNewTabButton: DevExpress.ui.dxButton.Properties;
        duplicateButton: DevExpress.ui.dxButton.Properties;
        expandButton: DevExpress.ui.dxButton.Properties;

        renameButton: DevExpress.ui.dxButton.Properties;
        renamePopoverComponent: DevExpress.ui.dxPopover;
        renamePopoverConfig: DevExpress.ui.dxPopover.Properties;
        renameComponent: Ir.Components.General.TextBox.ITextBoxComponent;
        renameConfig: Ir.Components.General.TextBox.ITextBoxParams;
        saveRenameConfig: DevExpress.ui.dxButton.Properties;
        cancelRenameConfig: DevExpress.ui.dxButton.Properties;
        widgetNameTmp: KnockoutObservable<string>;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        let self = this;
        self.config = params.config;
        self.dashboard = params.dashboard;
        self.dashboardWidget = params.dashboardWidget;
        self.isLoading = ko.observable(true);
        self.editing = self.config.generalSettings.editing;

        self.dashboardWidget.setdashboarWidgetElement(componentInfo.element);

        self.dashboardWidget.getWidgetData(function (result, error, errorMessage) {
            self.result = result;
            self.isLoading(false);
        });

        //Add the event here because Rich Text Widget links do not work when the event is by knockout
        $(componentInfo.element).on("click", function () { onWidgetClick(self.dashboardWidget); });

        self.dispose = function () {
            self.dashboardWidget.removeResizableDraggable();
        }

        self.detailButton = {
            hint: "Click to open a detail tab",
            icon: "more",
            visible: ko.computed(function () {
                return self.dashboardWidget.itemConfig() && self.dashboardWidget.itemConfig().allowDetailTab && self.dashboardWidget.tabDetailId();
            }) as any,
            onClick(e) {
                e.event.stopPropagation();

                if (self.dashboardWidget.tabDetailId()) {
                    let tabVM = workbook.workbookConfig.workbookHelper.workbookTabsDataSource().find(x => x.tabId === self.dashboardWidget.tabDetailId());
                    if (tabVM) {
                        if (tabVM.tab().tabContent) {
                            tabVM.tab().forceRefresh(true);
                        }

                        tabVM.tab().detailingWidget.tabId(workbook.workbookConfig.activeTab().id());
                        tabVM.tab().detailingWidget.tabName(workbook.workbookConfig.activeTab().name());
                        tabVM.tab().detailingWidget.widgetId(self.dashboardWidget.id());
                        tabVM.tab().detailingWidget.widgetName(self.dashboardWidget.name());

                        workbook.workbookConfig.setActiveTab(self.dashboardWidget.tabDetailId());
                    }
                }
            }
        }

        self.removeButton = {
            hint: "Remove Widget",
            icon: "trash",
            visible: workbook.workbookConfig.generalSettings.editing as any,
            onClick(e) {
                e.event.stopPropagation();
                self.dashboardWidget.remove();
            }
        };

        self.expandButton = {
            hint: "Expand Widget",
            icon: "ms ir-expand-icon",
            visible: ko.computed(function () { return !workbook.workbookConfig.generalSettings.editing() && self.dashboardWidget.expandEnabled; }) as any,
            onClick(e) {
                e.event.stopPropagation();
                self.dashboardWidget.expandCollapse();
            }
        };

        self.createNewTabButton = {
            hint: "Create as a new tab",
            icon: "ms ir-createNewTab-icon",
            visible: ko.computed(function () {
                return workbook.workbookConfig.generalSettings.editing() &&
                    (self.dashboardWidget.widgetType() === WidgetType.Report || self.dashboardWidget.widgetType() === WidgetType.Pivot || self.dashboardWidget.widgetType() === WidgetType.Chart);
            }) as any,
            onClick(e) {
                e.event.stopPropagation();
                self.dashboardWidget.createAsNewTab();
            }
        };

        self.duplicateButton = {
            hint: "Duplicate Widget",
            icon: "ms ir-duplicate-icon",
            visible: workbook.workbookConfig.generalSettings.editing as any,
            onClick(e) {
                e.event.stopPropagation();
                self.dashboardWidget.duplicate();
            }
        };

        self.renameButton = {
            hint: "Rename Widget",
            icon: "rename",
            visible: workbook.workbookConfig.generalSettings.editing as any,
            onClick(e) {
                e.event.stopPropagation();
                self.renamePopoverComponent.option("target", e.element);
                self.renamePopoverComponent.show();
            }
        };
        self.renamePopoverConfig = {
            width: 350,
            hideOnOutsideClick: function (e) {
                onCancelRenameWidget(self);
                return true;
            },
            onShowing(e) {
                $(".buttons", componentInfo.element).css("display", "block");
            },
            onHiding(e) {
                $(".buttons", componentInfo.element).css("display", "");
            },
            onInitialized(e) {
                self.renamePopoverComponent = e.component;
            }
        };

        self.widgetNameTmp = ko.observable(self.dashboardWidget.name());
        self.renameConfig = {
            text: self.widgetNameTmp,
            width: 270,
            onKeyUp(keyCode) {
                if (keyCode === 27) {//ESC
                    onCancelRenameWidget(self);
                }
                else if (keyCode === 13) {//ENTER
                    onSaveRenameWidget(self);
                }
            },
            validate(text) {
                return self.dashboard.widgets().filter(x => x.id() !== self.dashboardWidget.id() && x.name() === text).length === 0;
            },
            validateMessage: "Name is not unique",
            getComponent(component) {
                self.renameComponent = component
            }
        };
        self.saveRenameConfig = {
            icon: "save",
            hint: "Save",
            type: "success",
            onClick(e) {
                onSaveRenameWidget(self);
            }
        }
        self.cancelRenameConfig = {
            icon: "revert",
            hint: "Cancel",
            type: "danger",
            onClick(e) {
                onCancelRenameWidget(self);
            }
        }
    }

    function onWidgetClick(widget: DashboardWidget) {
        let selectedWidget = workbook.workbookConfig.activeTab().dashboard.selectedWidget();
        if (!selectedWidget || selectedWidget.id() !== widget.id()) {
            workbook.workbookConfig.activeTab().dashboard.selectWidget(widget);
        }
        else {
            //Commented to keep the widget always selected and avoid drilldown clicks issues
            //workbook.workbookConfig.activeTab().dashboard.selectWidget(null);
        }
    }

    function onCancelRenameWidget(self: IViewModel) {
        self.renameComponent.reset(self.dashboardWidget.name());
        self.renamePopoverComponent.hide();
    }
    function onSaveRenameWidget(self: IViewModel) {
        if (self.renameConfig.validate(self.widgetNameTmp())) {
            self.dashboardWidget.updateName(self.widgetNameTmp());
            self.renamePopoverComponent.hide();
        }
    }
}